import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {PAGES_AND_PATHS} from '../../../constants/pages-and-paths';
import {AuthGuardService} from '../../../guards/auth-guard.service';
import {AdminListComponent} from './admin-list.component';

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.adminList.pageInRouting,
    data: {data: PAGES_AND_PATHS.adminList},
    component: AdminListComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./admin-list.module').then(m => m.AdminListModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminListRoutingModule { }
